export default "__VITE_PUBLIC_ASSET__6edaa550__"